// Shared constants & styles for every dashboard card / chart.

export const RANGES = [
  { v: 1, label_fr: "24h", label_en: "24h" },
  { v: 7, label_fr: "7 j", label_en: "7d" },
  { v: 30, label_fr: "30 j", label_en: "30d" },
  { v: 90, label_fr: "90 j", label_en: "90d" },
];

// Brand palette for recharts pies/bars (gold-leaning gradient).
export const COLORS = [
  "#C5A059",
  "#A0834C",
  "#7D643A",
  "#F2EBE5",
  "#A19E9C",
  "#5A4727",
];

export const TOOLTIP_STYLE = {
  background: "#050505",
  border: "1px solid #C5A059",
  color: "#F2EBE5",
  fontSize: 12,
  borderRadius: 0,
};

// Network-aware label + color for the social-shares list. Defaults are
// safe so unknown networks still render something readable.
export const SHARE_NETWORK_META = {
  whatsapp: { fr: "WhatsApp", en: "WhatsApp", color: "#25D366" },
  linkedin: { fr: "LinkedIn", en: "LinkedIn", color: "#0A66C2" },
  facebook: { fr: "Facebook", en: "Facebook", color: "#1877F2" },
  twitter: { fr: "X / Twitter", en: "X / Twitter", color: "#F2EBE5" },
  copy_link: { fr: "Lien copié", en: "Copy link", color: "#C5A059" },
};
